// Draws the eye to a field Test drive says needs fixing: scrolls it into view,
// pulses an outline around it for a few seconds and focuses its first input.
// Fields opt in with data-fix-field="<name>" (names come from the backend's
// TestStep.fix_field).

const STYLE_ID = "jc-fix-highlight-style";
const CLASS = "jc-fix-highlight";
export const HIGHLIGHT_MS = 4500;

function ensureStyle(doc) {
  if (doc.getElementById(STYLE_ID)) return;
  const style = doc.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
@keyframes jcFixPulse {
  0%, 100% { box-shadow: 0 0 0 3px rgba(var(--orange-6), .55); }
  50% { box-shadow: 0 0 0 7px rgba(var(--orange-6), .18); }
}
.${CLASS} { border-radius: 8px; animation: jcFixPulse 1.1s ease-in-out 4; outline: 2px solid rgb(var(--orange-6)); outline-offset: 3px; }
@media (prefers-reduced-motion: reduce) { .${CLASS} { animation: none; } }`;
  doc.head.appendChild(style);
}

// highlightField returns whether the field was found.
export function highlightField(name, doc = document) {
  if (!name) return false;
  const el = Array.from(doc.querySelectorAll("[data-fix-field]")).find((n) => n.getAttribute("data-fix-field") === name);
  if (!el) return false;
  ensureStyle(doc);
  if (el.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "center" });
  el.classList.add(CLASS);
  const focusable = el.querySelector("input:not([type=hidden]), textarea, button, [tabindex]:not([tabindex='-1'])");
  if (focusable && focusable.focus) focusable.focus({ preventScroll: true });
  setTimeout(() => el.classList.remove(CLASS), HIGHLIGHT_MS);
  return true;
}
